var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95844 16.6001H5.69531C5.86005 17.066 6.30481 17.4001 6.82688 17.4001C7.34895 17.4001 7.7937 17.066 7.95844 16.6001Z",
    fill: "#AFD34F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2271 12.1999V6.60004C11.2271 4.42009 9.64196 2.60987 7.5613 2.26084C7.36844 2.22843 7.22728 2.06156 7.22728 1.86642V1.00002C7.22728 0.779173 7.04808 0.599976 6.82724 0.599976C6.60639 0.599976 6.42719 0.779173 6.42719 1.00002V1.86642C6.42719 2.06156 6.28603 2.22844 6.09317 2.26084C4.01244 2.61001 2.42734 4.42006 2.42734 6.60004V12.1999C2.42734 12.8627 1.89016 13.3999 1.22734 13.3999C0.564532 13.3999 0.0273438 13.9371 0.0273438 14.5999C0.0273438 15.2627 0.564532 15.7999 1.22734 15.7999H12.4271C13.0899 15.7999 13.6271 15.2627 13.6271 14.5999C13.6271 13.9371 13.0899 13.3999 12.4271 13.3999C11.7643 13.3999 11.2271 12.8627 11.2271 12.1999H11.2271Z",
    fill: "#AFD34F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.11bd77ab88d1d66988d9389aef618759.svg";
export { ForwardRef as ReactComponent };